module.exports = __webpack_public_path__ + "img/video-wiki.80cd512e.png";